// extracted by mini-css-extract-plugin
export default {"MobileMenu":"mobile-menu_MobileMenu__Mo+gl","active":"mobile-menu_active__ZzI0m"};